import React from 'react'

import './index.css'

import useDispatch from 'hooks/use-dispatch'
import useSelector from 'hooks/use-selector'

import ProductSlider from 'components/ProductSlider'
import loadRelatedProducts from 'modules/variant/redux/actions/load-related-products'

import getRelatedProducts from 'modules/variant/redux/selectors/get-related-products'

import logUtil from 'utils/log'
import Section from 'components/Section'

const TITLE = 'Customers also bought these products'

const ANALYTIC_EVENT_PREFIX = 'CUSTOMERS_ALSO_BOUGHT'

const SHOP_ALL_LABEL = 'Shop all'

export default function CustomersAlsoBoughtSlider (props) {
  const {
    isSample,
    isFullSize,
    isJustDroppedSlider,
    isGiftSetSlider,
    isSampleTab,
    productVariant
  } = props

  const dispatch = useDispatch()
  let relatedProducts = useSelector(getRelatedProducts)

  if (
    relatedProducts?.length &&
    relatedProducts?.length > 0
  ) {
    relatedProducts = relatedProducts?.filter((product) => {
      return product?.product_id !== Number(productVariant?.product_id)
    })
  }

  const loadProducts = () => {
    logUtil('CustomersAlsoBoughtSlider').debug('[start] loadProducts', props)
    dispatch(
      loadRelatedProducts({
        isFullSize,
        isGiftSetSlider,
        isSample,
        isJustDroppedSlider,
        sampleTabSelected: isSampleTab
      })
    )
  }

  const onClickTitleOrShopAll = (e) => {
    e.preventDefault()
    return false
  }

  return (
    <Section className='quick-shop-customers-also-like-slider'>
      <ProductSlider
        products={relatedProducts}
        shopAllLabel={SHOP_ALL_LABEL}
        title={TITLE}
        loadProducts={loadProducts}
        href='/'
        analyticEventPrefix={ANALYTIC_EVENT_PREFIX}
        onClickTitleOrShopAll={onClickTitleOrShopAll}
      />
    </Section>
  )
}
